import React from "react";

import StyledActionButtons from "./styles";

const ActionButtons = ({ children }) => <StyledActionButtons>{children}</StyledActionButtons>;

export default ActionButtons;
